import _ from 'lodash';
import { toLocaleString } from './strings';

export const handleOnChangeForNumbers = (e) => {
  const value = _.get(e, 'target.value') || null;

  const currentInputValue = _.get(e, 'target.defaultValue');

  if (currentInputValue === '0') {
    return String(value).replace('0', '');
  }

  return value;
};

export const withTargetValueFromEvent = (onChange) => (e) => onChange(handleOnChangeForNumbers(e));

const biggerOrEqualLimit = (value, limit) => value >= limit;
const smallerOrEqualLimit = (value, limit) => value <= limit;

const isString = (value) => typeof value === 'string';

export const toLocaleSeparatorNumber = (value) => {
  if (!value) return null;
  return toLocaleString(value);
};
export const comasToDots = (value) => (isString(value) ? value.replace(',', '.') : value);

const isInLimits = (value, limits) => {
  const valueWithComaToDots = comasToDots(value);
  return (
    biggerOrEqualLimit(valueWithComaToDots, limits.minimum)
    && smallerOrEqualLimit(valueWithComaToDots, limits.maximum)
  );
};

export const isCorrectUpdateForNumericInput = (value, limits) => !_.isNil(value) && isInLimits(value, limits);
